import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_38: FaireProductEntity = {
  token: "starter_collection_38",
  type: "product",
  name: "Totem Glasses - Provence",
  brandName: "Sophie Lou Jacobsen",
  imageUrl: "",
  priceDollars: 88,
  msrpDollars: 176,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
